module.exports = __webpack_public_path__ + "static/media/BG_Desktop.ecf15965.jpg";